import IntegrationsThridparties from '@/sections/integration/thirdparties/thirdparties-page.vue';

export default [
	{
		name: 'integrations-thirdparties',
		path: '/integrations/thirdparties',
		props: route => ({
			search: route.query.search || undefined,
			status: route.query.status || 'active',
			sortBy: route.query.sortBy || 'name',
			sortDirection: route.query.sortDirection || 'asc',
			thirdPartyId: route.query.thirdPartyId,
			count: parseInt(route.query.count)
		}),
		component: IntegrationsThridparties,
		meta: {
			permissions: ['integration.read']
		}
	}
];
